import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/service/auth.service';
import { GeneralService } from 'src/app/service/general.service';

@Component({
  selector: 'app-update-password',
  templateUrl: './update-password.component.html',
  styleUrls: ['./update-password.component.scss'],
})
export class UpdatePasswordComponent {
  receivedEmail: string = '';
  receivedPassword: string = '';
  confirmPassword: string = '';
  errorMessage: string = '';
  signinSuccess: boolean = false;
  processLoading: boolean = false;
  token: string;

  constructor(
    private authService: AuthService,
    private router: Router,
    private generalService: GeneralService,
    private route: ActivatedRoute
  ) {
    this.token = this.route.snapshot.params.token;
    // console.log(this.token);
  }

  ngOnInit(): void {}

  email(data: string) {
    this.receivedEmail = data;
  }
  password(data: string) {
    this.receivedPassword = data;
  }
  checkPassword(data: string) {
    this.confirmPassword = data;
  }

  updatePassword = () => {
    this.errorMessage = "";
    this.processLoading = true;
    if ([this.receivedEmail, this.receivedPassword, this.confirmPassword].includes("")) {
      this.errorMessage = "All fields are required.";
      this.processLoading = false;
    }
    else if (!this.generalService.validateEmailAddress(this.receivedEmail)) {
      this.errorMessage = "Please enter a valid email.";
      this.processLoading = false;
    }
    else if (this.receivedPassword !== this.confirmPassword) {
      this.errorMessage = "Passwords do not match.";
      this.processLoading = false;
    }
    const newDetails = {
      "emailAddress": this.receivedEmail,
      "password": this.receivedPassword,
      "verifyToken": this.token,
    };
    // console.log(this.receivedEmail);
    this.errorMessage = '';
    const isValid = this.authService.validateEmail(this.receivedEmail);
    if (!isValid) {
      this.errorMessage = 'please enter a valid email address';
    }
    this.authService.updatePassword(newDetails).subscribe((res: any) => {
      // if(!this.authService.validateEmailAddress(this.receivedEmail)){
      //   this.errorMessage = "Invalid Email Address"
      //   this.processLoading = false;
      //   return;
      // }
      if (res.statusCode === 200) {
        // this.generalService.setToken(res.data.accessToken);
        this.signinSuccess = true;
        // console.log('password reset successfully');
        this.router.navigate(['signin']);
        setTimeout(() => {
          this.processLoading = false;
        }, 2000);
      } else {
        this.processLoading = false;
        this.errorMessage = 'Problem resetting password';
      }
    });
  };
}
